import Vue from "vue";
import { searchpage } from "./searchpage";

const searchresults = Vue.component("searchresults", {
    template: 
    `
    <div class="searchresults">

        <div class="search-filters">
        <button class="filter-button" :class="{ active: filteredtype == index }" v-for="(item, index) in types" v-if="index == 'all'" v-on:click="filteredtype = index">{{item.name}}</button>
            <button class="filter-button" :class="{ active: filteredtype == index }" v-for="(item, index) in types" v-if="index != 'all' && results[index].items.length > 0" v-on:click="filteredtype = index">{{item.name}}</button>
        </div>



        <div class="container">
            <div v-if="(!results.page.items.length && !results.post.items.length)" class="no-results row">Ei hakua vastaavia tuloksia. Kokeile uudelleen toisella hakusanalla.</div>
            <div class="type row" v-for="(item, index) in results" :key="index" v-if="item.items.length && index == filteredtype  || item.items.length && filteredtype == 'all'">
                <div class="col-12">
                    <h3 class="result-type">{{item.title}}</h3>
                </div>

                <div class="col-md-4" :class="[post.type == 'post' ? 'post-holder' : 'page-holder']" v-for="post in item.items.slice(0, types[index].amount)" :key="post.id">
                    <a :href="post.link" class="result" :class="[post.type != 'page' ? ['card', 'card-result']: 'page']">
                        <div class="result-content">
                            <div class="top">
                                <p class="result-terms" v-if="post.type == 'post'">
                                    <span class="term category" v-for="category in post.categories">{{category}}</span>
                                    <span class="term topic" v-for="aihe in post.aiheet">{{aihe}}</span>
                                </p>
                                <h4 class="result-title">{{post.title}}</h4>
                                <p class="result-excerpt" v-if="post.type == 'page'" v-html="post.excerpt"></p>
                            </div>
                            <div class="bottom">
                                <p class="result-meta" v-if="post.type == 'post'">
                                    <span class="author" v-if="post.author">{{post.author}} -</span>
                                    <span class="date" v-if="post.date">{{post.date}}</span>
                                </p>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-12 d-flex justify-content-end" v-if="item.items.length > types[index].amount">
                    <button class="cta black cta-small" v-on:click="types[index].amount = types[index].amount+moreposts">Lataa lisää</button>
                </div>

            </div>
        </div>
    </div>`,

    props: ["results", "types"],

    data: function() {
        return {
            moreposts: 6,
            filteredtype: 'all'
        };
    },
    created: function() {
    },

    methods: {}
});

export { searchresults };
